import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ITeamTemplate} from './ITeamTemplate';
import {Observable} from 'rxjs';
import {TeamService} from '../services/team.service';
import {PortalBootstrapService} from '../services/portal-bootstrap.service';

@Injectable({providedIn: 'root'})
export class TeamTemplateResolver implements Resolve<ITeamTemplate> {
	constructor(private teamService: TeamService, private portalBootstrap: PortalBootstrapService) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ITeamTemplate> | Promise<ITeamTemplate> | ITeamTemplate {
		const routeParameter = route.paramMap.get('team');
		const result = this.teamService.getTeamInfoByTemplateName(routeParameter);
		// Apply this portal's Auth0 settings (synchronous) before the auth page activates, so
		// AuthPageComponent.ngOnInit can decide whether to redirect to Auth0. Needed for the
		// start-at-root flow, where the team isn't in the URL when the APP_INITIALIZER runs.
		this.portalBootstrap.loadForTeam(routeParameter);
		return result;
	}
}
